module.exports = __webpack_public_path__ + "img/buildingbreak.d3c30929.svg";